import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_email_message",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  ref: "emailMessageModalRef"
}
const _hoisted_2 = { class: "modal-dialog mw-550px" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = { class: "modal-header justify-content-end border-0 pb-0" }
const _hoisted_5 = { class: "col card-header ps-1" }
const _hoisted_6 = { class: "card-title text-start" }
const _hoisted_7 = { class: "svg-icon btn-icon svg-icon-3x me-2 svg-icon-primary" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "Compose Message", -1)
const _hoisted_9 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_10 = { class: "col svg-icon svg-icon-1" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-body p-0" }
const _hoisted_13 = { class: "d-block" }
const _hoisted_14 = { class: "d-flex align-items-center border-bottom px-8 min-h-50px" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-dark fw-bold me-5 w-65px" }, "To:", -1)
const _hoisted_16 = { class: "d-flex align-items-center border-bottom px-8 min-h-50px" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-dark fw-bold me-5 w-65px" }, "Subject:", -1)
const _hoisted_18 = {
  id: "kt_inbox_form_editor",
  class: "bg-transparent border-0 h-auto px-3 ql-container ql-snow"
}
const _hoisted_19 = { class: "text-center p-10" }
const _hoisted_20 = {
  type: "submit",
  ref: "submitButtonRef",
  class: "btn btn-lg btn-primary"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Send", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com010.svg" })
              ]),
              _hoisted_8
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_form, {
              id: "add_user_modal_form",
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              model: _ctx.targetData,
              ref: "formRef",
              class: "form"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.targetData.recipientemail,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetData.recipientemail) = $event)),
                      placeholder: _ctx.iboUserDetails.adminemail,
                      value: _ctx.iboUserDetails.adminemail
                    }, null, 8, ["modelValue", "placeholder", "value"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.targetData.subject,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.targetData.subject) = $event)),
                      placeholder: "Document Followup",
                      value: _ctx.targetData.subject
                    }, null, 8, ["modelValue", "value"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.targetData.textarea,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetData.textarea) = $event)),
                      class: "mt-5",
                      rows: 10,
                      type: "textarea",
                      placeholder: `Dear ${_ctx.iboUserDetails.adminfullname}, I was just checking up...`,
                      value: _ctx.targetData.textarea
                    }, null, 8, ["modelValue", "placeholder", "value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", _hoisted_20, _hoisted_23, 512)
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ])
      ])
    ])
  ], 512))
}